
import {store} from './store/actions';
String.prototype.norm = function () {
  return this.replace(/ /g, '_').replace(/[^a-zA-Z0-9_.-]/g, '').toLowerCase()
}
store.dispatch('init', store.state)
export default store